import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Service from "../Services/Service";
import loaderGif from "../Images/loader.gif";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Button, Modal, Box, TextField } from "@mui/material";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
let vGroupID = 0;
let arrSlctdGroup = [];

const UserGroup = () => {
  const [loading, setLoading] = useState(false);
  const txtGroup = useRef(null);
  const [userGroup, setGroup] = useState([]);
  const [editing, setEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [groupError, setGroupError] = useState("");

  useEffect(() => {
    Service.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/UserGroup");
    //Service.setApiUrl("https://localhost:7106/api/UserGroup");
    fetchGroup();
  }, []);

  const navigate = useNavigate();

  const fetchGroup = async () => {
    //debugger;
    const res = await Service.getAll();
    setGroup(res.data);
  };

  const clear = () => {
    vGroupID = 0;
    if (txtGroup.current) txtGroup.current.value = "";
    arrSlctdGroup = [];
    setEditing(false);
  };

  const handleDuplicate = async (e) => {
    if (vGroupID > 0 && e.target.value === arrSlctdGroup.groupName) return;

    const found = userGroup.some(
      (grp) =>
        grp.groupName.toLowerCase() === e.target.value.trim().toLowerCase(),
    );

    if (found) {
      alert("Duplicate Group!");
      e.target.value = "";
      e.target.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const groupName = txtGroup.current.value.trim();

    if (!groupName) {
      setGroupError("Group Name is required");
      return;
    }

    const groupNameRegex =
      /^(?=.*[A-Za-z0-9])[A-Za-z0-9._-]+(?: [A-Za-z0-9._-]+)*$/;

    if (!groupNameRegex.test(groupName)) {
      setGroupError("Only alphabets, numbers, spaces, hyphens (-) and underscores (_) are allowed");
      return;
    }

    setGroupError("");
    let strMsg =
      vGroupID === 0
        ? "User Group added successfully"
        : "User Group updated successfully";
    setLoading(true);
    try {
      await Service.create({
        GroupId: vGroupID,
        GroupName: groupName,
        OpFlag: editing ? "Update" : "Insert",
      });
      clear();
      fetchGroup();
      alert(strMsg);
      setOpen(false);
    } catch (error) {
      console.error("Error saving group:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (group) => {
    arrSlctdGroup = group;
    vGroupID = group.groupId;
    setEditing(true);
    setOpen(true);

    setTimeout(() => {
      if (txtGroup.current) txtGroup.current.value = group.groupName?.trim() || "";
    }, 0);
  };

  const handleAddClick = () => {
    clear();
    setOpen(true);
  };

  const handleDelete = async (groupId, opFlag) => {
    //debugger;
    if (window.confirm("Are you sure to delete this user group?")) {
      await Service.remove(groupId, opFlag);
      fetchGroup();
    }
  };

  // 🔹 Columns for MUI DataGrid
  const columns = [
    {
      field: "serialNo",
      headerName: "No.",
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },
    { field: "groupId", headerName: "ID" },
    { field: "groupName", headerName: "Group Name", flex: 1, sortable: true },
    {
      field: "actions",
      headerName: "Actions",
      width: 200, // 👈 make sure width is big enough
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            // justifyContent: "center",
            alignItems: "center",
            height: "100%",
            gap: "8px",
          }}
        >
          <Button
            variant="outlined"
            color="success"
            size="small"
            startIcon={<ModeEditOutlineRoundedIcon />}
            onClick={() => handleEdit(params.row)}
          >
            Edit
          </Button>
          <Button
            variant="outlined"
            color="error"
            size="small"
            startIcon={<DeleteRoundedIcon />}
            onClick={() => handleDelete(params.row.groupId, "Delete")}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <Box sx={{ width: "100%", px: 4, py: 2 }}>
      {" "}
      {/* px adds left/right padding */}
      {/* <Box
        sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }} // floating Add button
      >
        <Button variant="contained" onClick={handleAddClick}>
          Add Group
        </Button>
      </Box> */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/DashboardFinal")}
        >
          Back to Home
        </Button>
        <Button variant="contained" onClick={handleAddClick}>
          Add Group
        </Button>
      </Box>
      {/* MUI DataGrid with filtering + sorting + toolbar */}
      <DataGrid
        rows={userGroup}
        columns={columns}
        columnVisibilityModel={{
          groupId: false,
        }}
        getRowId={(row) => row.groupId}
        pageSize={5}
        rowsPerPageOptions={[5, 10, 20]}
        disableSelectionOnClick
        components={{ Toolbar: GridToolbar }}
        sx={{
          borderRadius: 2,
          border: "1px solid rgba(0,0,0,0.12)",
          "& .MuiDataGrid-cell": { py: 1 }, // vertical padding for cells
        }}
      />
      {/* Modal remains the same */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            width: 400,
          }}
        >
          <h4>{editing ? "Edit" : "Add"} Group</h4>
          <form onSubmit={handleSubmit}>
            <TextField
              inputRef={txtGroup}
              label="Group Name"
              fullWidth
              required
              error={!!groupError}
              helperText={groupError}
              sx={{ mb: 2 }}
              onChange={() => setGroupError("")}
              onBlur={handleDuplicate}
            />
            <Box display="flex" justifyContent="flex-end">
              <Button onClick={() => setOpen(false)} sx={{ mr: 1 }}>
                Cancel
              </Button>
              <Button type="submit" variant="contained">
                {editing ? "Update" : "Add"}
              </Button>
            </Box>
          </form>

          {loading && (
            <div className="loader-overlay">
              <img src={loaderGif} alt="Loading..." className="loader-img" />
            </div>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default UserGroup;
